var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.666 11.56v2a1.334 1.334 0 01-1.453 1.333 13.193 13.193 0 01-5.753-2.047 13 13 0 01-4-4 13.193 13.193 0 01-2.047-5.78A1.333 1.333 0 012.74 1.613h2A1.333 1.333 0 016.073 2.76a8.56 8.56 0 00.467 1.873 1.333 1.333 0 01-.3 1.407l-.847.846a10.666 10.666 0 004 4l.847-.846a1.334 1.334 0 011.406-.3 8.557 8.557 0 001.874.466 1.333 1.333 0 011.146 1.354z",
    stroke: "#616161",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/media/phone-icon.7594c317.svg";
export { SvgPhoneIcon as ReactComponent };